import React from 'react'
import './Footer.scss'
import Forbes from '../Images/forbes.svg'
import Meta from '../Images/meta.svg'
import Clutch from '../Images/Clutchbig.svg'
import GoogleP from '../Images/googlepartner.svg'
import Adobe from '../Images/adobe.svg'
import BlueCoastLogo from '../Images/blue-coast-logo.avif'
import StrategyIco from '../Images/strategy-ico.avif'
import CreativityIco from '../Images/creativity-ico.avif'
import BeyondIco from '../Images/beyond-ico.avif'

const Footer = () => {
  return (
    <div className='footer full-width'>
      <div className='content main-grid'>

        <div className='partners-container'>
          <img src={Forbes} alt='forbes logo' />
          <img src={Meta} alt='meta logo' />
          <img src={Clutch} alt='clutch logo' />
          <img src={GoogleP} alt='google partner logo' />
          <img src={Adobe} alt='adobe logo' />
        </div>

        <div className='footer-middle'>

          <div className='left'>
            <a href='./'>
              <img src={BlueCoastLogo} alt='blue coast studio logo' className='bc-logo' />
            </a>
            <p className='inter-font'>
              Join the exceptional world of modern websites and discover the limitless possibilities that await you.
            </p>
          </div>

          <div className='middle'>
            <div className='icon-container'>
              <div className='icon-div'>
                <img src={CreativityIco} alt='' className='icon creativity-icon' />
                <h2 className='unbounded-font'>CREATIVITY</h2>
              </div>
              <div className='icon-div'>
                <img src={StrategyIco} alt='' className='icon strategy-icon' />
                <h2 className='unbounded-font'>STRATEGY</h2>
              </div>
              <div className='icon-div'>
                <img src={BeyondIco} alt='' className='icon beyond-icon' />
                <h2 className='unbounded-font'>BEYOND</h2>
              </div>

            </div>

          </div>

          <div className='right'>
            <div className='right-left'>
              <h4 className='unbounded-font'>CONTACT</h4>
            </div>
            <div className='right-right'>
              <p className='inter-font'>
              Virtual 3D Mauritius<br /> Villa Royalle Unit 5<br /> Grand Baie<br /> Mauritius 
              </p>
              <br />
              <a href="tel:+23058150447" className='inter-font'>+23 058 15 04 47</a><br />
              <br />
              <a href="mailto:office@bluecoaststudio.mu" className='inter-font'>office@bluecoaststudio.mu</a>
            </div>

          </div>
        </div>

        <div className='footer-bottom'>
          <span className='unbounded-font'>©2024 Blue Coast Studio. All rights reserved.</span>
          <a href='./privacy-policy' className='unbounded-font'>Privacy Policy</a>
          <span className='unbounded-font'>Design and implementation: Blue Coast Studio</span>


        </div>

      </div>
    </div>
  )
}

export default Footer